module.exports = __webpack_public_path__ + "media/assets/checkbox-checked-a6a1fd961a43bd12ea0ce077ff0836b5b2b56c1ad1d2ba92097778065d1290f9.png";